<template>

  <popup
     :heading="heading"
     button-style="primary"
     :round="round"
     :button-size="size"
     :show-text="showText"
     button-text="Add"
     button-icon="fa fa-broadcast-tower"
     :disableButton="!(isTowerSupplierCo() || isTowerCo()) || !isManager('project|maintenance|management') || readOnly || this.isActive"
     @save="onSaveDialog"
     @close="onCloseDialog">

    <struct-details
      ref="sd"
      :site-id="siteId"
      :editMode="true"
      :adding="true"
      :hide-panel="true"
      :table-ref="tableRef"
      :read-only="readOnly"
      @update="updatedStruct"
    />

  </popup>

</template>


<script>

import StructDetails from '@/components/tables/details/StructDetails'

export default {

  components: {
    StructDetails
  },



  props: {

    heading: {
      type: String,
      default: 'Add Structure'
    },

    showText: {
      type: Boolean,
      default: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    tableRef: {
      type: String,
      default: 'structtable'
    },

    siteId: {
      type: Number,
      default: null
    },

    isActive: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'small'
    },

    round: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }
  },



  methods: {

    updatedStruct (i, data, adding = false) {
      this.$emit('update', i, data, adding)
    },

    onSaveDialog () {
      this.$refs.sd.onSave()
      this.$emit('update-stats')
    },

    onCloseDialog () {
      this.$refs.sd.onClose()
      this.$emit('update-stats')
    }

  },
/*
  created () {
    console.log('isActive', this.isActive)
  }
*/
}

</script>



// WEBPACK FOOTER //
// StructureAction.vue?3d4faaaa